import { createRoute } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';
import { IntegrationDetailPage } from './IntegrationDetailPage';
import { getIntegrationConfig } from 'src/config/integrations';
import { IntegrationKey } from '@erp/rpc';
import z from 'zod';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/integrations/$integrationKey',
  component: IntegrationDetailPage,
  params: z.object({
    integrationKey: z.enum(IntegrationKey),
  }),
  loader: ({ params }) => {
    const integrationKey = params.integrationKey;
    const config = getIntegrationConfig(integrationKey);
    return {
      crumb: config.name,
    };
  },
});
